import Container from "./containers/Container";

const PreservedAres = {
    Container,
}

export {PreservedAres}